import { useState, useEffect } from "react";
import CloseIcon from "../assets/crossIcon.svg";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { RpaServices } from "../services/RpaServices";
const UpdateMultipleRequestStatus = ({ setOpen, requestIds, oldStatus }) => {
  const [requestStatus, setRequestStatus] = useState("");
  const handleSubmit = async () => {
    const data = {
      requestIds: requestIds,
      requestStatus,
      statusRemark: "Manually Updated",
      oldStatus: oldStatus,
    };
    // console.log(data);
    try {
      const response = await RpaServices.updateMultipleRequestsStatus(data);
      if (response?.status === 200) {
        alert("Request status updated successfully!");
        setOpen(false);
      } else {
        alert("Failed to update request status.");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="fixed w-screen h-screen top-0 left-0 flex justify-center items-center bg-[#017C5780] z-10">
      <div className="relative w-[50%] h-fit bg-white rounded-[16px] px-4 py-8">
        <div className="absolute right-4 top-4">
          <img
            src={CloseIcon}
            alt="close-icon"
            className="cursor-pointer"
            onClick={() => setOpen(false)}
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="requestStatus"
              value="NEW"
              checked={requestStatus === "NEW"}
              onChange={(e) => setRequestStatus(e.target.value)}
            />
            <span>NEW</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="requestStatus"
              value="HOLD"
              checked={requestStatus === "HOLD"}
              onChange={(e) => setRequestStatus(e.target.value)}
            />
            <span>HOLD</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="requestStatus"
              value="COMPLETED"
              checked={requestStatus === "COMPLETED"}
              onChange={(e) => setRequestStatus(e.target.value)}
            />
            <span>COMPLETED</span>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="requestStatus"
              value="STARTMANUALLY"
              checked={requestStatus === "STARTMANUALLY"}
              onChange={(e) => setRequestStatus(e.target.value)}
            />
            <span>STARTMANUALLY</span>
          </label>
        </div>
        <div className="flex justify-center items-center mt-4">
          <button
            className="align-self-center text-sm text-[#017C57] font-semibold px-6 py-1 rounded-full bg-white border border-[#017C57]  sm:w-auto cursor-pointer"
            onClick={handleSubmit}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateMultipleRequestStatus;
